import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { OperationalType } from "../../app/types/genericTables.types";

type UseOperational = {
  operationalList: OperationalType[];
  get: (id: OperationalType["id"]) => OperationalType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useOperational = create<UseOperational>((set, get) => ({
  loading: false,
  operationalList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) =>
    get().operationalList.find((operational) => operational.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/Operacional";
      const { data: response } = await getData(endpoint);
      set(() => ({
        operationalList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching useOperational:", error);
      set({ loading: false });
    }
  },
}));
